import { React, useState } from 'react';

// components
import { Button } from "shared/components/bulma/button";

import * as helper from "./helper";

const InvestigateButton = ({ item, hidden, onChange }) => {
    const [newLog, setNewLog] = useState(item.log);

    const handleInvestigate = () => {
        helper.markAsInvestigate(item);
        newLog.investigated = true;
        setNewLog({ ...newLog });
    };

    if (item.status !== 'missing') {
        return null;
    };

    const buttonClasses = 'is-info';
    const hiddenClass = hidden ? 'is-hidden' : '';
    const outlinedClass = newLog && newLog.investigated ? '' : 'is-outlined';

    const investigateButtonClasses = [
        buttonClasses,
        outlinedClass,
        hiddenClass
    ].join(' ');

    return (
        <Button name="investigate" className={investigateButtonClasses} onClick={handleInvestigate}>
            Investigate
        </Button>
    )
}

export { InvestigateButton };
